import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export function Placeholder() {
  return (
    <Box
      data-login-widget-placeholder
      sx={{
        width: "10rem",
        height: "10rem",
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
